<div class="d-flex flex-column justify-content-center align-items-center">
    <div class="text-center process-step-title process-step-title text-montserrat">Paso 3</div>
    <div class="text-center my-2 text-montserrat">Firma de Aceptación</div>
    <div class="text-center my-1 text-montserrat">
        Por último solo se requiere tu firma para proceder
    </div>
    <div class="container-firma border-lightgray w-100 mt-3">
        <div class="container-firma-header text-center py-1 text-montserrat">Firma Digital</div>
        <div id="canvasPadre" #canvasPadre class="container-firma-content">
            <canvas class="canvas-firma" id="firma" #normalCanvas></canvas>
            <canvas class="canvas-scale" id="firmaScale" #scaledCanvas hidden></canvas>
        </div>
        
    </div>
    <div class="container-firma-footer  border-lightgray d-flex justify-content-between align-items center w-100 p-1 mb-2">
        <button mat-flat-button (click)="limpiarFirma()">Limpiar</button>
        <button mat-flat-button class="bg-blue-inter white" (click)="guardarFirma()">Guardar</button>
    </div>
</div>